<div class="detail-trajet">
	<div class="detail-trajet-header">
		<div class="date-trajet">
			{{ trajet().dateDepart | date: 'EEEE dd/MM' | premiereLettreMajusculePipe }}
		</div>
		<p-button class="bouton-fermer"
		          icon="pi pi-times"
		          styleClass="p-button-link"
		          (onClick)="fermerDetailTrajet()">
		</p-button>
	</div>
	<div class="detail-trajet-contenu">
		<app-affichage-depart-arrivee [trajet]="trajet()"></app-affichage-depart-arrivee>
		<div class="section-detail-trajet">
			<div class="titre-section">
				{{ 'GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.TITRE_REMPLISSAGE' | translate }}
			</div>
			<div class="conteneur-section">
				<div>
					{{ 'GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.PLACES_TOTALES' | translate : { nombre: trajet().nombrePlaces } }}
				</div>
				<div>
					{{ 'GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.PLACES_RESTANTES' | translate : { nombre: trajet().nombrePlaces - trajet().nombreReservations } }}
				</div>
				<div>
					{{ 'GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.TAUX_REMPLISSAGE' | translate : { pourcentage: tauxRemplissage() | number:'1.0-2' } }}
				</div>
				<div class="statut-trajet">
					<div>
						{{ 'GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.STATUT_TRAJET' | translate }}
					</div>
					<app-label-statut-trajet [statut]="trajet().statut"></app-label-statut-trajet>
				</div>
			</div>
		</div>
		<div class="section-detail-trajet">
			<app-liste-reservations></app-liste-reservations>
		</div>
		<div class="section-detail-trajet">
			<app-informations-utiles [informations]="trajet().information"></app-informations-utiles>
		</div>
	</div>
	<div class="detail-trajet-footer">
		<p-button icon="fa fa-edit"
		          label="{{ 'GLOBAL.BTN_MODIFIER' | translate }}"
		          (onClick)="basculerEnModeModification()"
		          [disabled]="estTrajetPasse() || estTrajetAnnule()">
		</p-button>
		<p-button icon="pi pi-trash"
		          severity="danger"
		          label="{{ 'GLOBAL.BTN_ANNULER' | translate }}"
		          (onClick)="afficherConfirmationAnnulation()"
		          [disabled]="estTrajetPasse() || estTrajetAnnule()">
		</p-button>
	</div>
</div>
